import { clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import styles from "./yarn-preview-grid.module.css";

export const YarnDisplayText = ({ children, className, ...props }: ComponentProps<"div">) => {
	return (
		<div className={clsx(styles.yarnDisplayText, className)} {...props}>
			<span>Farge</span> <span className={styles.yarnColor}>{children}</span>
		</div>
	);
};
